import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 当前企业已授权的品牌列表
export const setAuthedBrandPage: Mutation<IModuleState> = (state, payload) => {
  state.authedBrandPage.data = payload.data;
  state.authedBrandPage.pageNum = payload.pageNum;
  state.authedBrandPage.pageSize = payload.pageSize;
  state.authedBrandPage.total = payload.total;
  state.authedBrandPage.loading = !!payload.loading;
};

// 指定品牌已授权的企业列表
export const setAuthedOrgPage: Mutation<IModuleState> = (state, payload) => {
  state.authedOrgPage.data = payload.data;
  state.authedOrgPage.pageNum = payload.pageNum;
  state.authedOrgPage.pageSize = payload.pageSize;
  state.authedOrgPage.total = payload.total;
  state.authedOrgPage.loading = !!payload.loading;
};
